// Copyright 2016 Sorama B.V.

export class ClientVersionError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = "ClientVersionError";
    }
}
